import { Fragment } from 'react';
import Header from './components/Header';
import HeroSlider from './components/HeroSlider';
import MissionVision from './components/MissionVision';
import Timeline from './components/Timeline';
import StaffStats from './components/StaffStats';
import Facilities from './components/Facilities';
import Research from './components/Research';
import ContactForm from './components/ContactForm';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';
import './styles/global.css';

export function HomePage() {
  return (
    <Fragment>
        <div className="home-landipage">
          <Header />
          <HeroSlider />
          <MissionVision />
          <Timeline />
          <StaffStats />
          <Facilities />
          <Research />
          <ContactForm />
          <Footer />
          <ScrollToTop />
        </div>
    </Fragment>
  );
}